import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  CardGroup,
  Card,
  CardBody,
  Button,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from "reactstrap";
import AuthService from "../../../components/AuthService";
import { ToastContainer, toast } from "react-toastify";
import ContentLoader from "react-content-loader";

class Login extends Component {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleForgottenPassword = this.handleForgottenPassword.bind(this);
    this.handleRegister = this.handleRegister.bind(this);
    this.Auth = new AuthService();
  }

  validateField(fieldName, value) {
    if (value == null) {
      return false;
    }
    switch (fieldName) {
      case "email":
        return value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        break;
      case "password":
        return value.length >= 4;
        break;
      default:
        return true;
        break;
    }
  }

  notifyError(err) {
    toast.error(err);
  }

  notifySuccess(msg) {
    toast.success(msg);
  }

  handleForgottenPassword(e) {
    e.preventDefault();
    this.props.history.replace("/forgottenpassword");
  }

  handleRegister(e) {
    e.preventDefault();
    this.props.history.replace("/register");
  }

  handleFormSubmit(e) {
    e.preventDefault();
    if (!this.state || !this.state.emailVerif || !this.state.passwordVerif) {
      this.notifyError(
        "Veuillez reessayer. Les informations entrées ne sont pas correctes ou manquantes."
      );
      return;
    }
    this.setState({ loading: true });
    this.Auth.login(this.state.email, this.state.password)
      .then(res => {
        this.setState({ loading: false });
        this.props.history.replace("/");
        this.notifySuccess(
          'Bienvenue sur le tableau de bord Happy Quest "' +
            this.Auth.getProfile().sub +
            '" !'
        );
      })
      .catch(err => {
        this.setState({ loading: false });
        this.notifyError(err.response.data);
      });
  }

  handleChange(e) {
    if (e.target.name == "email") {
      e.target.value = e.target.value.trim();
    }
    this.setState({
      [e.target.name]: e.target.value
    });
    if (e.target.name == "email") {
      if (this.validateField("email", e.target.value)) {
        this.setState({ emailVerif: true });
      } else {
        this.setState({ emailVerif: false });
      }
    } else {
      if (this.validateField("password", e.target.value)) {
        this.setState({ passwordVerif: true });
      } else {
        this.setState({ passwordVerif: false });
      }
    }
  }

  componentWillMount() {
    if (this.Auth.loggedIn()) {
      this.props.history.replace("/");
    }
  }

  componentDidMount() {
    this.setState({ emailVerif: false, passwordVerif: false });
  }

  render() {
    let content, loading, emailStyle, passwordStyle;
    if (!this.state) {
      content = (
        <ContentLoader
          height={200}
          width={400}
          speed={2}
          primaryColor={"#f3f3f3"}
          secondaryColor={"#ecebeb"}
        >
          <rect x="7" y="17" rx="4" ry="4" width="126.36" height="11.14" />
          <rect x="11" y="33.9" rx="3" ry="3" width="107.1" height="11.26" />
          <rect x="3" y="58" rx="3" ry="3" width="385" height="28.48" />
          <rect x="3" y="95" rx="3" ry="3" width="385" height="28.48" />
          <rect x="9" y="143.9" rx="0" ry="0" width="105" height="24" />
          <rect x="310" y="153.9" rx="0" ry="0" width="78" height="9" />
        </ContentLoader>
      );
    } else {
      if (this.state.loading) {
        loading = (
          <img
            src="/img/loading_icon.gif"
            style={{
              height: "auto",
              width: "auto",
              maxWidth: 70 + "px",
              maxHeight: 70 + "px"
            }}
          />
        );
      }

      if (this.state.emailVerif) {
        emailStyle = { borderColor: "green" };
      }

      if (this.state.passwordVerif) {
        passwordStyle = { borderColor: "green" };
      }

      content = (
        <CardBody>
          <h1>Tableau de bord Happy Quest</h1>
          <p className="text-muted">Connexion</p>
          <form onSubmit={this.handleFormSubmit}>
            <InputGroup className="mb-3">
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="fa fa-user" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                placeholder="Email"
                name="email"
                id="email"
                type="text"
                onChange={this.handleChange}
                style={emailStyle}
                required
              />
            </InputGroup>
            <InputGroup className="mb-3">
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="fa fa-lock" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                placeholder="Mot de passe"
                name="password"
                id="password"
                type="password"
                onChange={this.handleChange}
                style={passwordStyle}
                required
              />
            </InputGroup>
            <Row>
              <Col xs="6">
                <Button
                  type="submit"
                  id="login"
                  color="primary"
                  className="px-4"
                >
                  Se connecter
                </Button>
                {loading}
              </Col>
              <Col xs="6" className="text-right">
                <Button
                  id="register"
                  color="link"
                  className="px-0"
                  onClick={this.handleRegister}
                >
                  S'inscrire
                </Button>
                <br/>
                <Button
                  id="forgottenPassword"
                  color="link"
                  className="px-0"
                  onClick={this.handleForgottenPassword}
                >
                  Mot de passe oublié ?
                </Button>
              </Col>
            </Row>
          </form>
        </CardBody>
      );
    }
    return (
      <div className="app flex-row align-items-center">
        <ToastContainer />
        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              <CardGroup>
                <Card className="p-4">{content}</Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js